// 图片压缩方法
import Pica from "pica";

const picaInstance = Pica();

export async function compressImage(file) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = img.width;
            canvas.height = img.height;

            picaInstance.resize(img, canvas, { unsharpAmount: 80, unsharpRadius: 0.6, unsharpThreshold: 2 })
                .then(() => {
                    canvas.toBlob(blob => {
                        resolve(new File([blob], file.name, { type: file.type }));
                    }, file.type);
                })
                .catch(reject);
        };
        img.onerror = reject;
        img.src = URL.createObjectURL(file);
    });
}